import { Controller } from "@hotwired/stimulus"

// Shows or hides the typed password behind an eye button next to the field.
// The field turns back into a password field before its form submits, so the
// browser's password manager still recognizes what was saved, and before Turbo
// caches the page, whose snapshot only blanks fields of type "password".
export default class extends Controller {
  static targets = ["input", "button", "showIcon", "hideIcon"]
  static values = { showLabel: String, hideLabel: String }

  connect() {
    this.form = this.inputTarget.form
    this.boundHide = this.hide.bind(this)
    this.form?.addEventListener("submit", this.boundHide)
    document.addEventListener("turbo:before-cache", this.boundHide)
    this.render()
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.boundHide)
    document.removeEventListener("turbo:before-cache", this.boundHide)
  }

  toggle() {
    this.inputTarget.type = this.visible ? "password" : "text"
    this.render()
  }

  hide() {
    this.inputTarget.type = "password"
    this.render()
  }

  // The label names the action ("anzeigen"/"verbergen"), so there is no aria-pressed:
  // a pressed state on top of a changing label is announced as a contradiction.
  render() {
    const visible = this.visible
    const label = visible ? this.hideLabelValue : this.showLabelValue

    this.buttonTarget.setAttribute("aria-label", label)
    this.buttonTarget.title = label
    this.showIconTarget.classList.toggle("hidden", visible)
    this.hideIconTarget.classList.toggle("hidden", !visible)
  }

  get visible() {
    return this.inputTarget.type === "text"
  }
}
